import React from 'react';
import theme from '@shared/utils/themeColors';

interface CheckboxControlProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  error?: string | null;
  className?: string;
  description?: string;
}

const CheckboxControl: React.FC<CheckboxControlProps> = ({
  id,
  label,
  checked,
  onChange,
  disabled = false,
  error = null,
  className = '',
  description,
}) => {
  return (
    <div className={`flex items-start ${className}`}>
      <div className="flex items-center h-5">
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className={`form-checkbox h-4 w-4 ${error ? 'border-red-500' : ''}`}
        />
      </div>
      <div className="ml-3 text-sm">
        <label
          htmlFor={id}
          className={`font-medium ${theme.text.secondary} ${disabled ? 'opacity-70' : ''}`}
        >
          {label}
        </label>
        {description && (
          <p className="text-gray-500 dark:text-gray-400 text-xs mt-1">{description}</p>
        )}
        {error && <div className="text-red-500 text-xs mt-1">{error}</div>}
      </div>
    </div>
  );
};

export default CheckboxControl;
